import { LEVEL_ADMIN } from '../../plugins/checkPermission'
import { db, auth, firebase, firestore, functions } from '../../plugins/firebase'

const state = {
    id: null,
    level: null,
    user: null,
    list_users: [],
    profile: null,
    collection: null,
    ready: false,
    aux: {}
}

const getters = {
    getUser: state => user =>  state.list_users.find( u => u.id === user ),
    getUsersAdmin: state => state.list_users.filter( u => u.level === LEVEL_ADMIN )
}

const actions = {
    async init({ state, commit, dispatch }, user){
        return new Promise(async (resolve, reject) => {
            if(user){
                commit('UPDATE_DATA', user)
                commit('UPDATE_COLLECTION', user.id)

                let profile = await state.collection.get()
                commit('UPDATE_PROFILE', profile.data())

                await dispatch('fetchUsers')
                commit('SET_READY', true)
                return resolve()
            }else{
                commit('UPDATE_DATA', null)
                commit('SET_READY', false)
                return resolve()
            }
        })
    },
    fetchUsers({ state, commit }){
        return new Promise(async (resolve, reject) => {
            try {
                const response = await db.collection(`users_solar/${state.id}/users`).get()
                commit('SET_USERS', response.docs.map( m => ({ ...m.data(), id: m.id })))
                return resolve()
            } catch (error) {
                console.log(error)
            }
        })
    },
    getUserWithPlants({ state }){
        return new Promise(async (resolve, reject) => {
            try {
                const response = await db.collection('users_solar').where('account', '==', state.id ).orderBy('plants').get()
                const data = response.docs.map( m => ({ ...m.data(), id: m.id }))
                resolve(data.filter( doc => doc.plants.length > 0 ))
            } catch (error) {
                console.log(error)
                return reject()
            }
        })
    },
    getPlantsUsers({ state, rootState }, user){
        return new Promise(async (resolve, reject) => {
            try {
                const user_data = (await db.doc(`users_solar/${user}`).get()).data()
                const plants = user_data.plants ? user_data.plants: []
                return resolve(plants)
            } catch (error) {
                return resolve([])
            }
        })
    },
    editUserPlants({ commit }, payload){
        return new Promise(async (resolve, reject) => {
            try {
                await db.doc(`users_solar/${payload.user}`).update({ plants: payload.plants })
                commit('UPDATE_PROFILE_USER', {
                    user: payload.user,
                    data: {
                        plants: payload.plants
                    }
                })
                return resolve()
            } catch (error) {
                console.log(error)
                return resolve()
            }
        })
    },
    editUserLevel({ state, commit }, payload){
        return new Promise(async (resolve, reject) => {
            try{
                await db.doc(`users_solar/${payload.user}`).update({
                    level: payload.level,
                })
                await db.doc(`users_solar/${state.id}/users/${payload.user}`).update({
                    level: payload.level
                })
                commit('UPDATE_PROFILE_USER', {
                    user: payload.user,
                    data: {
                        level: payload.level
                    }
                })
                return resolve()
            }catch(error){
                console.log(error)
                return resolve()
            }
        })
    },
    addUser({ state, commit }, user){
        return new Promise(async (resolve, reject) => {
            try {
                if(!state.aux.auxApp)
                    state.aux.auxApp = firebase.initializeApp(firebase.app().options, 'auth-worker')
                if(!state.aux.auxAuth){
                    state.aux.auxAuth = firebase.auth(state.aux.auxApp)
                    state.aux.auxAuth.setPersistence(firebase.auth.Auth.Persistence.NONE)
                }

                const user_ = await state.aux.auxAuth.createUserWithEmailAndPassword(user.email, user.password)

                await db.doc(`users_solar/${user_.user.uid}`).set({
                    level: user.level,
                    account: state.id
                })
                await db.doc(`users_solar/${state.id}/users/${user_.user.uid}`).set({
                    email: user.email,
                    level: user.level
                })
                commit('ADD_USER', {
                    id: user_.user.uid,
                    level: user.level,
                    email: user.email
                })

                return resolve()
            } catch (error) {
                if(error) return reject({ message: error.message })
                return reject({ message: '' })
            }
        })
    },
    deleteUser({ state, commit }, user){
        return new Promise(async (resolve, reject) => {
            try {
                const functionDelete = functions.httpsCallable('deleteUser')
                const res = await functionDelete({ user: user })
                
                await db.doc(`users_solar/${user}`).delete()
                await db.doc(`users_solar/${state.id}/users/${user}`).delete()

                commit('DELETE_USER', user)
                return resolve()
            } catch (error) {
                console.log(error)
                return reject()
            }
        })
    },
    updatedRates({ state, commit }, payload) {
        const { old_rate, new_rate } = payload
        return new Promise(async (resolve, reject) => {
            try {
                await state.collection.update({
                    rates: firestore.FieldValue.arrayRemove(old_rate)
                });
                await state.collection.update({
                    rates: firestore.FieldValue.arrayUnion(new_rate)
                });
                commit('UPDATE_RATE', new_rate)
                return resolve()
            } catch (error) {
                console.log(error)
                return reject()
            }
        })
    },
    updatedAlerts({ state, commit }, payload) {
        let { alert, value } = payload
        value = value * 60

        return new Promise(async (resolve, reject) =>{
            try {
                const data = {}
                data[alert] = value
                await state.collection.update(data)
                commit('UPDATE_ALERT', { alert, value })
                return resolve()
            } catch (error) {
                console.log(error)
                return reject()
            }
        })
    },
}

const mutations = {
    UPDATE_COLLECTION(state, account){
        account 
            ? state.collection = db.doc(`users_solar/${account}`)
            : state.collection = null
    },
    UPDATE_DATA(state, payload){
        if(!payload) return
        state.id = payload.id
        state.level = payload.level
        state.user = payload.user
    },
    UPDATE_PROFILE(state, payload){
        if(!payload) return
        payload.rates = payload.rates.sort((a, b) => {
            const nameA = a.name.toUpperCase();
            const nameB = b.name.toUpperCase();
            return (nameA < nameB) ? -1 : (nameA > nameB) ? 1 : 0;
        });
        state.profile = payload
    },
    UPDATE_PROFILE_USER(state, payload){
        const index = state.list_users.findIndex( u => u.id === payload.user )
        for (let key in payload.data) {
            state.list_users[index][key] = payload.data[key]
        }
    },
    UPDATE_RATE(state, rate){
        const index = state.profile.rates.findIndex( r => r.name == rate.name )
        state.profile.rates[index] = rate
    },
    UPDATE_ALERT(state, payload){
        state.profile[payload.alert] = payload.value
    },
    SET_READY(state, payload){
        state.ready = payload
    },
    SET_USERS(state, users){
        state.list_users = users
    },
    DELETE_USER(state, user){
        const index = state.list_users.findIndex( u => u.id == user )
        state.list_users.splice(index, 1);
    },
    ADD_USER(state, user){
        state.list_users.push(user)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
